"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.success.completed': '¡Onboarding completado exitosamente! Su asistente de IA está listo.',
    'onboarding.success.progress_saved': 'Progreso guardado exitosamente',
};
